
// ── Tag Badge ──────────────────────────────────────────────────────────────────
export const tagStyles: Record<string, React.CSSProperties> = {
    "tag-airfryer": { background: "#E1F5EE", color: "#0F6E56" },
    "tag-pan": { background: "#E6F1FB", color: "#185FA5" },
    "tag-blender": { background: "#FAEEDA", color: "#854F0B" },
    "tag-marinade": { background: "#EEEDFE", color: "#534AB7" },
    "tag-drink": { background: "#FDE8F5", color: "#8B2A6E" },
    "tag-chicken": { background: "#FFF3E0", color: "#8B5E00" },
    "tag-tofu": { background: "#E8F5E9", color: "#2E7D32" },
    "tag-snack": { background: "#F3E5F5", color: "#6A1B9A" },
    "tag-dessert": { background: "#FCE4EC", color: "#880E4F" },
    "tag-mainDish": { background: "#E3F2FD", color: "#1565C0" },
    "tag-sauce": { background: "#F1F8E9", color: "#33691E" },
};